<template>
  <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        color="info"
        v-on="on"
        v-bind="attrs"
        :block="isMobile()"
        depressed
      >
        {{ parametros.possui_senha_compra_prazo ? "Alterar" : "Configurar" }}
        senha <v-icon right>mdi-pencil-lock-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="green lighten-4 primary--text text-darken-4 font-weight-bold"
        >Configurar senha</v-card-title
      >
      <v-card-text>
        <v-form ref="form" class="mt-5">
          <v-text-field
            label="Nova Senha"
            class="campo-senha"
            :type="exibirSenha ? 'text' : 'password'"
            :append-icon="exibirSenha ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="exibirSenha = !exibirSenha"
            v-mask="maskFormatted()"
            v-model="cfg_senha.senha"
            :rules="rulesSenha()"
          ></v-text-field>
          <v-text-field
            label="Confirmar Senha"
            class="campo-senha"
            v-mask="maskFormatted()"
            v-model="cfg_senha.conf_senha"
            :type="exibirConfSenha ? 'text' : 'password'"
            @click:append="exibirConfSenha = !exibirConfSenha"
            :append-icon="exibirConfSenha ? 'mdi-eye-off' : 'mdi-eye'"
            :rules="rulesSenha()"
          ></v-text-field>
          <v-row class="mt-3">
            <v-col cols="6">
              <v-btn
                block
                color="success"
                class="font-weight-bold"
                rounded
                :loading="salvandoSenha"
                @click="salvarSenha()"
                >Salvar</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn
                block
                rounded
                @click="dialog = false"
                :disabled="salvandoSenha"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.cfg_senha.senha = "";
        this.cfg_senha.conf_senha = "";
      }
    },
  },
  computed: {
    ...mapState("configComprasPrazo", [
      "parametros",
      "cfg_senha",
      "salvandoSenha",
    ]),
  },
  data: () => ({
    dialog: false,
    exibirSenha: false,
    exibirConfSenha: false,
  }),
  methods: {
    ...mapActions("configComprasPrazo", [
      "configurarSenha",
      "buscarParametros",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
    maskFormatted() {
      return "#".repeat(this.parametros.num_dig_senha);
    },
    rulesSenha() {
      return [
        (v) =>
          v.length == this.parametros.num_dig_senha ||
          `Senha deve conter ${this.parametros.num_dig_senha} dígitos`,
      ];
    },
    async salvarSenha() {
      if (this.$refs.form.validate()) {
        var ret = await this.configurarSenha();
        if (ret) {
          this.dialog = false;
          await this.buscarParametros();
        }
      }
    },
  },
};
</script>

<style>
.campo-senha input {
  letter-spacing: 5px !important;
  font-family: "archivo black" !important;
  font-size: 1.5rem;
}
</style>